import React from 'react'
import { Shield } from 'lucide-react'

const AdminDebug = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <Shield className="h-8 w-8 text-primary-600" />
              <h1 className="ml-3 text-2xl font-bold text-gray-900">Admin Dashboard (Debug)</h1>
            </div>
            <div className="flex items-center space-x-4">
              <a href="/" className="text-primary-600 hover:text-primary-700">← Back to Trust Center</a>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Admin Debug Page</h2>
          <div className="space-y-4">
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <h3 className="text-green-800 font-medium">✅ Page Loading</h3>
              <p className="text-green-700 text-sm">This admin debug page is loading successfully.</p>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h3 className="text-blue-800 font-medium">🔍 Testing Functions</h3>
              <div className="space-y-2 mt-2">
                <button
                  onClick={() => {
                    fetch('/api/documents')
                      .then(r => r.json())
                      .then(d => {
                        console.log('Documents API:', d)
                        alert('Documents API working! Check console.')
                      })
                      .catch(e => {
                        console.error('Documents API error:', e)
                        alert('Documents API error: ' + e.message)
                      })
                  }}
                  className="mr-2 px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
                >
                  Test Documents API
                </button>

                <button
                  onClick={() => {
                    fetch('/api/admin/requests')
                      .then(r => r.json())
                      .then(d => {
                        console.log('Admin Requests API:', d)
                        alert('Admin Requests API working! Check console.')
                      })
                      .catch(e => {
                        console.error('Admin Requests API error:', e)
                        alert('Admin Requests API error: ' + e.message)
                      })
                  }}
                  className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
                >
                  Test Admin Requests API
                </button>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <h3 className="text-yellow-800 font-medium">⚠️ Known Issues</h3>
              <ul className="text-yellow-700 text-sm mt-2 list-disc list-inside space-y-1">
                <li>Admin authentication might be failing</li>
                <li>API calls might be timing out</li>
                <li>Netlify Functions might need time to cold start</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminDebug